module.exports = __webpack_public_path__ + "static/media/Document.6e63a14e.svg";